/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../base';
// @ts-ignore
import type { AdminDeleteFaqByFaqUuidNotFoundDto } from '../../src/model';
// @ts-ignore
import type { AdminGetFaqsInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { AdminGetFaqsOkDto } from '../../src/model';
// @ts-ignore
import type { AdminPatchFaqByFaqUuidBadRequestSortOrderDto } from '../../src/model';
// @ts-ignore
import type { AdminPatchFaqByFaqUuidInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { AdminPatchFaqByFaqUuidNotFoundDto } from '../../src/model';
// @ts-ignore
import type { AdminPatchFaqByFaqUuidOkDto } from '../../src/model';
// @ts-ignore
import type { AdminPatchFaqByFaqUuidReqBodyDto } from '../../src/model';
// @ts-ignore
import type { AdminPostFaqCreatedDto } from '../../src/model';
// @ts-ignore
import type { AdminPostFaqInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { AdminPostFaqReqBodyDto } from '../../src/model';
// @ts-ignore
import type { CreateWithTargetUuidInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { JwtAdminAccessGuardUnauthorizedDto } from '../../src/model';
/**
 * AdminFaqsApi - axios parameter creator
 * @export
 */
export const AdminFaqsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 어드민 FAQ 삭제
         * @param {string} faqUuid faq uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFaqControllerAdminDeleteFaqByFaqUuid: async (faqUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'faqUuid' is not null or undefined
            assertParamExists('adminFaqControllerAdminDeleteFaqByFaqUuid', 'faqUuid', faqUuid)
            const localVarPath = `/admin/faqs/{faqUuid}`
                .replace(`{${"faqUuid"}}`, encodeURIComponent(String(faqUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 어드민 FAQ 목록 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFaqControllerAdminGetFaqs: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/faqs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 어드민 FAQ 수정
         * @param {string} faqUuid faq uuid
         * @param {AdminPatchFaqByFaqUuidReqBodyDto} adminPatchFaqByFaqUuidReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFaqControllerAdminPatchFaqByFaqUuid: async (faqUuid: string, adminPatchFaqByFaqUuidReqBodyDto: AdminPatchFaqByFaqUuidReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'faqUuid' is not null or undefined
            assertParamExists('adminFaqControllerAdminPatchFaqByFaqUuid', 'faqUuid', faqUuid)
            // verify required parameter 'adminPatchFaqByFaqUuidReqBodyDto' is not null or undefined
            assertParamExists('adminFaqControllerAdminPatchFaqByFaqUuid', 'adminPatchFaqByFaqUuidReqBodyDto', adminPatchFaqByFaqUuidReqBodyDto)
            const localVarPath = `/admin/faqs/{faqUuid}`
                .replace(`{${"faqUuid"}}`, encodeURIComponent(String(faqUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminPatchFaqByFaqUuidReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 어드민 FAQ 생성
         * @param {AdminPostFaqReqBodyDto} adminPostFaqReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFaqControllerAdminPostFaq: async (adminPostFaqReqBodyDto: AdminPostFaqReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminPostFaqReqBodyDto' is not null or undefined
            assertParamExists('adminFaqControllerAdminPostFaq', 'adminPostFaqReqBodyDto', adminPostFaqReqBodyDto)
            const localVarPath = `/admin/faqs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminPostFaqReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminFaqsApi - functional programming interface
 * @export
 */
export const AdminFaqsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminFaqsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 어드민 FAQ 삭제
         * @param {string} faqUuid faq uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminFaqControllerAdminDeleteFaqByFaqUuid(faqUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminFaqControllerAdminDeleteFaqByFaqUuid(faqUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminFaqsApi.adminFaqControllerAdminDeleteFaqByFaqUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 어드민 FAQ 목록 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminFaqControllerAdminGetFaqs(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminGetFaqsOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminFaqControllerAdminGetFaqs(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminFaqsApi.adminFaqControllerAdminGetFaqs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 어드민 FAQ 수정
         * @param {string} faqUuid faq uuid
         * @param {AdminPatchFaqByFaqUuidReqBodyDto} adminPatchFaqByFaqUuidReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminFaqControllerAdminPatchFaqByFaqUuid(faqUuid: string, adminPatchFaqByFaqUuidReqBodyDto: AdminPatchFaqByFaqUuidReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminPatchFaqByFaqUuidOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminFaqControllerAdminPatchFaqByFaqUuid(faqUuid, adminPatchFaqByFaqUuidReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminFaqsApi.adminFaqControllerAdminPatchFaqByFaqUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 어드민 FAQ 생성
         * @param {AdminPostFaqReqBodyDto} adminPostFaqReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminFaqControllerAdminPostFaq(adminPostFaqReqBodyDto: AdminPostFaqReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminPostFaqCreatedDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminFaqControllerAdminPostFaq(adminPostFaqReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminFaqsApi.adminFaqControllerAdminPostFaq']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminFaqsApi - factory interface
 * @export
 */
export const AdminFaqsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminFaqsApiFp(configuration)
    return {
        /**
         * 
         * @summary 어드민 FAQ 삭제
         * @param {AdminFaqsApiAdminFaqControllerAdminDeleteFaqByFaqUuidRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFaqControllerAdminDeleteFaqByFaqUuid(requestParameters: AdminFaqsApiAdminFaqControllerAdminDeleteFaqByFaqUuidRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminFaqControllerAdminDeleteFaqByFaqUuid(requestParameters.faqUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 어드민 FAQ 목록 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFaqControllerAdminGetFaqs(options?: RawAxiosRequestConfig): AxiosPromise<AdminGetFaqsOkDto> {
            return localVarFp.adminFaqControllerAdminGetFaqs(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 어드민 FAQ 수정
         * @param {AdminFaqsApiAdminFaqControllerAdminPatchFaqByFaqUuidRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFaqControllerAdminPatchFaqByFaqUuid(requestParameters: AdminFaqsApiAdminFaqControllerAdminPatchFaqByFaqUuidRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminPatchFaqByFaqUuidOkDto> {
            return localVarFp.adminFaqControllerAdminPatchFaqByFaqUuid(requestParameters.faqUuid, requestParameters.adminPatchFaqByFaqUuidReqBodyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 어드민 FAQ 생성
         * @param {AdminFaqsApiAdminFaqControllerAdminPostFaqRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFaqControllerAdminPostFaq(requestParameters: AdminFaqsApiAdminFaqControllerAdminPostFaqRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminPostFaqCreatedDto> {
            return localVarFp.adminFaqControllerAdminPostFaq(requestParameters.adminPostFaqReqBodyDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminFaqControllerAdminDeleteFaqByFaqUuid operation in AdminFaqsApi.
 * @export
 * @interface AdminFaqsApiAdminFaqControllerAdminDeleteFaqByFaqUuidRequest
 */
export interface AdminFaqsApiAdminFaqControllerAdminDeleteFaqByFaqUuidRequest {
    /**
     * faq uuid
     * @type {string}
     * @memberof AdminFaqsApiAdminFaqControllerAdminDeleteFaqByFaqUuid
     */
    readonly faqUuid: string
}

/**
 * Request parameters for adminFaqControllerAdminPatchFaqByFaqUuid operation in AdminFaqsApi.
 * @export
 * @interface AdminFaqsApiAdminFaqControllerAdminPatchFaqByFaqUuidRequest
 */
export interface AdminFaqsApiAdminFaqControllerAdminPatchFaqByFaqUuidRequest {
    /**
     * faq uuid
     * @type {string}
     * @memberof AdminFaqsApiAdminFaqControllerAdminPatchFaqByFaqUuid
     */
    readonly faqUuid: string

    /**
     * 
     * @type {AdminPatchFaqByFaqUuidReqBodyDto}
     * @memberof AdminFaqsApiAdminFaqControllerAdminPatchFaqByFaqUuid
     */
    readonly adminPatchFaqByFaqUuidReqBodyDto: AdminPatchFaqByFaqUuidReqBodyDto
}

/**
 * Request parameters for adminFaqControllerAdminPostFaq operation in AdminFaqsApi.
 * @export
 * @interface AdminFaqsApiAdminFaqControllerAdminPostFaqRequest
 */
export interface AdminFaqsApiAdminFaqControllerAdminPostFaqRequest {
    /**
     * 
     * @type {AdminPostFaqReqBodyDto}
     * @memberof AdminFaqsApiAdminFaqControllerAdminPostFaq
     */
    readonly adminPostFaqReqBodyDto: AdminPostFaqReqBodyDto
}

/**
 * AdminFaqsApi - object-oriented interface
 * @export
 * @class AdminFaqsApi
 * @extends {BaseAPI}
 */
export class AdminFaqsApi extends BaseAPI {
    /**
     * 
     * @summary 어드민 FAQ 삭제
     * @param {AdminFaqsApiAdminFaqControllerAdminDeleteFaqByFaqUuidRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFaqsApi
     */
    public adminFaqControllerAdminDeleteFaqByFaqUuid(requestParameters: AdminFaqsApiAdminFaqControllerAdminDeleteFaqByFaqUuidRequest, options?: RawAxiosRequestConfig) {
        return AdminFaqsApiFp(this.configuration).adminFaqControllerAdminDeleteFaqByFaqUuid(requestParameters.faqUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 어드민 FAQ 목록 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFaqsApi
     */
    public adminFaqControllerAdminGetFaqs(options?: RawAxiosRequestConfig) {
        return AdminFaqsApiFp(this.configuration).adminFaqControllerAdminGetFaqs(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 어드민 FAQ 수정
     * @param {AdminFaqsApiAdminFaqControllerAdminPatchFaqByFaqUuidRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFaqsApi
     */
    public adminFaqControllerAdminPatchFaqByFaqUuid(requestParameters: AdminFaqsApiAdminFaqControllerAdminPatchFaqByFaqUuidRequest, options?: RawAxiosRequestConfig) {
        return AdminFaqsApiFp(this.configuration).adminFaqControllerAdminPatchFaqByFaqUuid(requestParameters.faqUuid, requestParameters.adminPatchFaqByFaqUuidReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 어드민 FAQ 생성
     * @param {AdminFaqsApiAdminFaqControllerAdminPostFaqRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFaqsApi
     */
    public adminFaqControllerAdminPostFaq(requestParameters: AdminFaqsApiAdminFaqControllerAdminPostFaqRequest, options?: RawAxiosRequestConfig) {
        return AdminFaqsApiFp(this.configuration).adminFaqControllerAdminPostFaq(requestParameters.adminPostFaqReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }
}

